import useMutationApi from 'src/api/useMutationApi';

interface RetrySendEdiAckResponse {
  success: boolean;
  message: string;
}

const useRetrySendEdiAck = (
  salesOrderId: string,
  onSuccess?: (response: RetrySendEdiAckResponse) => void,
) => {
  return useMutationApi<void, RetrySendEdiAckResponse>({
    endpoint: `accounts-receivable/sales-orders/${salesOrderId}/retry-send-edi-ack`,
    method: 'POST',
    options: {
      onSuccess: (response) => {
        onSuccess?.(response.data);
      },
    },
    showSuccessToast: true,
    successMessage: 'EDI acknowledgment resent successfully',
    showErrorToast: true,
    errorMessage: 'Failed to resend EDI acknowledgment',
  });
};

export default useRetrySendEdiAck;
